import React from 'react';

const LoaderDotts = () => {

    return (
        <div className="loader-container">
            <div className="dot dot-1"></div>
            <div className="dot dot-2"></div>
            <div className="dot dot-3"></div>
        </div>
    );
};

export default LoaderDotts;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/loader/LoaderDotts.js